export enum StateSignUp {
  Candidate,
  Manager,
  Recruiter
}
